import TranslationsList from "./translations-list";
export default TranslationsList;